import { json2csv } from 'json-2-csv';
import { saveAs } from 'file-saver';

import { ExportData } from '../types';

const BOM = '\uFEFF';

export const exportCSV = async (data: ExportData) => {
  try {
    const csv = await json2csv(data, {
      delimiter: {
        field: ';',
      },
      expandArrayObjects: true,
    });

    const blob = new Blob([BOM + csv], {
      type: 'text/csv;charset=utf-8;',
    });
    saveAs(blob, 'export.csv');
  } catch (error) {
    console.error('Export failed', error);
  }
};
